export default {
  refreshOn: ({ selectedDate }) => ([selectedDate]),
  'Calendar.Dates.CellWrapper.Day': ({ date, disabled }, outlet) => {
    if (disabled) return;
    outlet({ selectedDate: date })
  }
}